import { UserSignUpAxios, CourseAxios, DetailAxios, LoginAxios } from "./Axios_Services";

export const UserSignUpServices = new UserSignUpAxios();
export const CourseServices = new CourseAxios();
export const DetailServices = new DetailAxios();
export const LogInServices = new LoginAxios()
